/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import type { CCMCluster } from '@modules/ccm-components/ClusterTable'

import type { CCMService } from './types'

export function connectedClustersURL() {
  return '/connected-clusters'
}

export function connectClusterURL() {
  return '/connect-cluster-services'
}

export function getLinkedServiceUrl(service: CCMService, _cluster: CCMCluster): string | undefined {
  switch (service) {
    case 'auto_ops':
      return 'https://www.elastic.co' // TODO: https://github.com/elastic/cloud/issues/143473
    default:
      return undefined
  }
}
